class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    console.log(triggeredBy,123456789)
    // 测试变化
    document.querySelectorAll(".cart-item__name").forEach((item) => {
        item.textContent = item.textContent.replace('111', '234')
      });
    
    if (!triggeredBy) {
      getCart()
    }
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active')
      console.log(myGlobalVariable,'myGlobalVariable')
      const paypal = document.querySelector('[onclick*="itcCartDrawerPayPal"]')
      isNone(paypal,'paypal')
      const btn = document.querySelector('[onclick*="itcCartDrawerCheckout"]')
      if (btn) {
          // 为元素添加样式
          btn.style.width = '100%';
          btn.style.padding = '15px';
          btn.style.background = '#000';
          btn.style.color = '#fff';
          btn.style.border = 'none';
          btn.style.borderRadius = '7px';
          btn.style.fontSize = '16px';
          btn.style.fontWeight = '500';
          btn.style.cursor = 'pointer';
      }    
      isNone(btn,'credit_card')
    });

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}


// 获取购物车
async function getCart() {
  try {
    const response = await fetch("/cart.js");
    const cart = await response.json();
    if (cart) {
      window.windowCart = cart;
      if (window.windowCart?.items) {
        console.log('触发了AddToCart')
        windowCart.items.forEach((item) => {
          fbq("track", "AddToCart", {
            content_name: item.product_title,
            content_category: item.product_type,
            content_ids: [item.id],
            content_type: item.product_type,
            value: item.price / 100,
            currency: "USD",
          });
        });

        const items = windowCart.items.map((item) => {
          return {
            item_id: item.id || 123,
            item_name: item.title,
            price: item.final_price / 100,
            quantity: item.quantity,
            image_url: item.image,
            item_variant_id: item.variant_id,
            item_category_id: 166,
          };
        });
        axon("track", "add_to_cart", {
          currency: windowCart.currency ?? "USD",
          items: items,
          value: windowCart.total_price / 100,
        });
      }
    }
  } catch (error) {
    console.error("获取购物车信息错误:", error);
  }
}

// 设置isNone
function isNone(dom, str) {
  dom.style.display = "none";

  if (myGlobalVariable.paypal.enabled && myGlobalVariable.paypal.type == str) {
    dom.style.display = "block";
  }
  if (
    myGlobalVariable.worldxinpay.enabled &&
    myGlobalVariable.worldxinpay.type == str
  ) {
    dom.style.display = "block";
  }
}
customElements.define('cart-drawer-items', CartDrawerItems);
